import {InsuranceEN} from "./insurance/en";
import {DecisionEN} from "./decision/en";
import {RecordEN} from "./record/en";
import {CompetencyAssessmentEN} from "./competency-assessment/en";
import {ReportEN} from "./report/en";
import {OkrsEN} from "./okr/en";

export const PersonnelEN = {
    ...InsuranceEN,
    ...DecisionEN,
    ...RecordEN,
    ...CompetencyAssessmentEN,
    ...ReportEN,
    ...OkrsEN
}